<template>
  <VSlideYReverseTransition>
    <div v-if="show && loading" class="support-popup-component pa-3">
      <div class="mb-3">
        Zendesk is loading...
      </div>
      <VProgressCircular :size="24" color="primary" indeterminate />
    </div>
  </VSlideYReverseTransition>
</template>

<script>
import { SHOW_SUPPORT_POPUP } from '@/store/mutations'
import { DISPLAY_NOTIFICATION } from '@/store/actions'
import loadScript from '@/utils/loadScript'
import runDelayedMixin from '@/mixins/runDelayedMixin'

export default {
  name: 'SupportPopup',

  mixins: [runDelayedMixin],

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters.user
    },

    show: {
      get() {
        return this.$store.state.showSupportPopup
      },
      set(value) {
        this.$store.commit(SHOW_SUPPORT_POPUP, { show: value })
      },
    },
  },

  watch: {
    show(next, previous) {
      if (next === previous) return
      if (next) {
        this.onOpenZendesk()
      }
    },
  },

  methods: {
    async onOpenZendesk() {
      this.loading = true
      const zEtags = []
      if (
        this.user.authorized_bucket.some(
          b => this.$store.getters.bucketPlan(b.id).name === 'enterprise',
        )
      ) {
        zEtags.push('enterprise')
      }
      // Sadly Zendesk needs its settings in global
      window.zESettings = {
        webWidget: {
          contactForm: {
            tags: zEtags,
          },
        },
      }
      let zE
      try {
        zE = await this.loadZendesk()
      } catch (e) {
        this.$store.dispatch(DISPLAY_NOTIFICATION, {
          type: 'error',
          message:
            'Failed to load our support widget.  If you are using an ad-blocker, please try to disable it.',
        })
        this.loading = false
        return
      }
      const user = this.user

      zE.setLocale('en-US')

      zE.identify({
        name: user.username,
        email: user.email,
        organization: user.info && user.info.company,
        // enterprise: user.authorized_bucket.some(buck => buck.type === 'enterprise')
      })

      zE.activate({ hideOnClose: true })

      this.trackClose()

      this.loading = false
    },

    trackClose() {
      this.runDelayed(
        'track-close',
        () => {
          const widget = document.querySelector('.zEWidget-webWidget-active')
          if (!widget) {
            this.show = false
          } else {
            this.trackClose()
          }
        },
        50,
      )
    },

    async loadZendesk() {
      await loadScript(
        'https://static.zdassets.com/ekr/snippet.js?key=508570b2-0777-4810-b765-9dd667f58a1c',
        {
          id: 'ze-snippet',
        },
      )

      await new Promise(resolve => window.zE(resolve))

      window.zE.hide()

      await new Promise(resolve => {
        function checkFrame() {
          const frame = document.querySelector('.zEWidget-launcher')
          // Wait for the frame to load, else the zE.activate won't work (the widget isn't listening
          // to the 'activate' event)
          if (frame && frame.contentDocument.readyState === 'complete') {
            resolve()
          } else {
            setTimeout(checkFrame, 50)
          }
        }
        checkFrame()
      })

      return window.zE
    },
  },
}
</script>

<style lang="postcss" scoped>
.support-popup-component {
  position: fixed;
  bottom: 16px;
  right: 16px;

  /* Above the KPIDashboardPage/ComponentPicker component */
  z-index: 203;

  display: flex;
  flex-direction: column;
  align-items: center;

  /* Zendesk style */
  width: 342px;
  background-color: #fbfbfb;
  color: #2f3941;
  border-radius: 0.57143rem;
}
</style>

<style lang="postcss">
.zEWidget-webWidget.zEWidget-webWidget--active {
  right: 0 !important;
  left: auto !important;
}
</style>
